export default __webpack_public_path__ + "f3254a74c7f2d9b53d2b31032c4aa08e.svg";